import { ReactNode } from 'react';
import { cn } from '../../util';
import { InputLabel } from './TextInput';

export interface NumberInputProps extends React.HTMLAttributes<HTMLInputElement> {
  name?: string;
  min?: number;
  max?: number;
  value?: number;
  label?: string | ReactNode;
  placeholder?: string;
  disabled?: boolean;
  step?: number;
  errorMessage?: string;
  className?: string;
  testId?: string;
  required?: boolean;
  hideSpinner?: boolean;
}

export const NumberInput = ({
  value,
  label,
  placeholder,
  disabled,
  step,
  errorMessage,
  onChange,
  testId,
  className,
  required,
  hideSpinner,
  ...props
}: NumberInputProps) => {
  return (
    <div className={cn('flex w-full flex-col', className)}>
      {label && <InputLabel required={required}>{label}</InputLabel>}

      <div className="bg-primary border-input-border flex max-h-[36px] items-center rounded-md border px-3 py-2 text-sm">
        <input
          type="number"
          className={cn(
            `text-input-text placeholder:text-muted-foreground/80 w-full flex-1 bg-transparent leading-5 focus:outline-none`,
            disabled && `text-input-disabled-text cursor-not-allowed`,
            hideSpinner &&
              `[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none`
          )}
          value={value ?? ''}
          placeholder={placeholder}
          onChange={onChange}
          disabled={disabled}
          step={step}
          data-testid={testId}
          {...props}
        />
      </div>

      {errorMessage && <div className="text-error mt-2 text-sm">{errorMessage}</div>}
    </div>
  );
};
